import React,{createContext,useContext,useEffect,useState,useRef} from "react";
import {auth,db} from "../firebase/firebase";
import {doc,getDoc} from "firebase/firestore";

const BrandingContext=createContext();
export const useBranding=()=>useContext(BrandingContext);

export function BrandingProvider({children}){
  const [theme,setTheme]=useState(null);
  const [loading,setLoading]=useState(true);

  // 🔒 prevents re-running forever
  const hasLoaded=useRef(false);

  useEffect(()=>{
    if(hasLoaded.current) return;

    const unsub=auth.onAuthStateChanged(async(user)=>{
      try{
        if(!user){
          applyCSSVars(defaultTheme);
          setTheme(defaultTheme);
          return;
        }

        const userSnap=await getDoc(doc(db,"users",user.uid));
        if(!userSnap.exists()){
          applyCSSVars(defaultTheme);
          setTheme(defaultTheme);
          return;
        }

        const resellerId=userSnap.data().resellerId;
        if(!resellerId){
          applyCSSVars(defaultTheme);
          setTheme(defaultTheme);
          return;
        }

        const brandSnap=await getDoc(
          doc(db,"resellers",resellerId,"branding","settings")
        );

        if(brandSnap.exists()){
          applyCSSVars(brandSnap.data());
          setTheme(brandSnap.data());
        }else{
          applyCSSVars(defaultTheme);
          setTheme(defaultTheme);
        }
      }catch(err){
        console.warn("Branding fallback:",err.message);
        applyCSSVars(defaultTheme);
        setTheme(defaultTheme);
      }finally{
        hasLoaded.current=true;
        setLoading(false);
      }
    });

    return()=>unsub();
  },[]);

  return(
    <BrandingContext.Provider value={{theme,loading}}>
      {children}
    </BrandingContext.Provider>
  );
}

const defaultTheme={
  primary:"#7c3aed",
  background:"#0b0b0b",
  accent:"#a78bfa",
  text:"#ffffff",
  logoURL:""
};

function applyCSSVars(theme){
  if(!theme) return;
  const root=document.documentElement;
  root.style.setProperty("--primary",theme.primary);
  root.style.setProperty("--background",theme.background);
  root.style.setProperty("--accent",theme.accent);
  root.style.setProperty("--text",theme.text);
}
